import React from "react";
import styles from "../styles/TagFree.module.css";

export default function TagFree() {
  return <span className={styles.free}>無料</span>;
}
